import {UserRolesEnum} from '../../shared/interfaces/UserRolesEnum';

export const userRolesOptions = [
  {
    id: UserRolesEnum.PharmacyStaff,
    name: 'Pharmacy Staff',
    description: 'User can create records and view inventory.',
  },
  {
    id: UserRolesEnum.PharmacyAdmin,
    name: 'Pharmacy Admin',
    description: 'User can manage other users.',
  },
];
